import {Auth} from "@digatex/digatex-ui-lib";
import {Button, Modal} from "antd";
import {useLocation} from "react-router-dom";

import styles from "./NoPermissionModal.module.css";

export const NoPermissionModal = ({requiredApi, landingPath, onGoToLanding}) => {
	const location = useLocation();

	const tokenParsed = Auth.tokenParsed();
	const roles = tokenParsed?.resource_access?.[requiredApi]?.roles ?? [];

	const hasPermission = roles.length > 0;
	const isLandingPage = landingPath && location.pathname.startsWith(landingPath);

	if (hasPermission || isLandingPage) {
		return null;
	}

	return (
		<Modal
			open={true}
			closable={false}
			maskClosable={false}
			title="Access Restricted"
			styles={{mask: {backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)"}}}
			footer={
				<div className={styles.modalFooter}>
					<Button key="landing" onClick={onGoToLanding}>
						Go to Landing
					</Button>
					<Button key="logout" type="primary" onClick={() => Auth.logout()}>
						Log out
					</Button>
				</div>
			}>
			<p>You don't have permission to view this page. Please contact your administrator.</p>
		</Modal>
	);
};
